import {effects} from 'redux-saga';
import VolatileActions from '../volatile/volatileRedux';
import {AppReduxTypes} from './appRedux';
import {getJwtToken, validateJwtToken} from '../sagaAuth/sagaAuthSaga';
import AuthActions, {SagaAuthReduxTypes} from '../sagaAuth/sagaAuthRedux';
import {LanguageSwitcherReduxTypes} from '../languageSwitcher/languageSwitcherRedux';

export const officeListCompleteFnc = (state) => state.Volatile.officeListComplete;
export const changeLanguageCompleteFnc = (state) => state.Volatile.changeLanguageComplete;

const tag = '[STARTUP]';

function* waitForStartupSequenceToFinish() {

    const changeLanguageComplete = yield effects.select(changeLanguageCompleteFnc);
    if (!changeLanguageComplete) {
        console.log(`${tag} Going to wait for CHANGE_LANGUAGE to finish`);
        yield effects.take(LanguageSwitcherReduxTypes.CHANGE_LANGUAGE);
    }
    else {
        console.log(`${tag} CHANGE_LANGUAGE already complete..`);
    }

    const officeListComplete = yield effects.select(officeListCompleteFnc);
    if (!officeListComplete) {
        // -------------------------------------------------------------------------------------------------\
        // NOTE: DO NOT DELETE THE FOLLOWING FOR REFERENCE REASON                                           |
        // console.log(`${tag} Going to wait for OFFICE_LIST_FAILURE|OFFICE_LIST_SUCCESS to finish`);       |
        // yield effects.take(action => /^OFFICE_LIST_FAILURE|OFFICE_LIST_SUCCESS/.test(action.type));      |
        // -------------------------------------------------------------------------------------------------/
        console.log(`${tag} Going to wait for SET_CURRENT_OFFICE to finish`);
        yield effects.take(SagaAuthReduxTypes.SET_CURRENT_OFFICE);
    }
    else {
        console.log(`${tag} SET_CURRENT_OFFICE already complete..`);
    }

    // check for the user token..
    const userToken = yield getJwtToken();
    // use that to try get user profile
    if (userToken) {
        console.log(`${tag} stored jwtToken found : ${userToken}`);
        yield validateJwtToken(userToken); // this will log user out if it is an invalid login
    }
    else {
        yield effects.put(AuthActions.requestLogout());
        console.log(`${tag} stored jwtToken is not found`);
    }


    console.log(`${tag} startup sequence complete..`);


}


export function* startup() {
    try {
        yield waitForStartupSequenceToFinish();

        // yield delay(5000);
        yield effects.put(VolatileActions.startupComplete());

    } catch (e) {
        console.warn(`${tag} Failed to startup : ${e.message}`);
    }


}

export default function* rootSaga() {
    yield effects.all([effects.takeLatest(AppReduxTypes.STARTUP, startup)]);
}



// WEBPACK FOOTER //
// ./src/redux/app/appSaga.ts